/**
 *
 * Ripspot Memorial
 *
 */

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { navigate } from 'gatsby';

import Button from 'components/Elements/Button';
import PhotoGallery from 'components/PhotoGallery';
import SocialShare from 'components/SocialShare';
import { Comments } from 'components/Comments';
import { getBioMarkup } from 'utils/helperFunctions/ripspots';
// import { convertNumbersToDate } from 'utils/helperFunctions/dates';
// import { toastInfo } from 'utils/toastify';

const RipspotMemorial = ({
  ripspot,
  onViewRipspotClick,
  isPreview = false,
  isModal = false,
  showComments,
}) => {
  const [bioMarkup, setBioMarkup] = useState('');
  const [birthYear, setBirthYear] = useState('');
  const [deathYear, setDeathYear] = useState('');
  const [shareURL, setShareURL] = useState('');

  // some may not exist due to isPreview
  const {
    name,
    birthDate,
    deathDate,
    biography,
    bio,
    photoGallery,
    pins,
  } = ripspot;
  const hasMultiplePins = pins ? pins.length > 1 : false;

  useEffect(() => {
    if (biography) {
      const markup = biography.text.split('<p><br></p>').join(''); // , options // see bottom of file below for options example
      setBioMarkup(markup);
    } else if (isPreview && bio.text) {
      try {
        const markup2 = bio.text.split('<p><br></p>').join(''); // , options // see bottom of file below for options example

        setBioMarkup(markup2);
      } catch (markup2) {}
    }
  }, [biography, bio]);

  useEffect(() => {
    if (birthDate) {
      //
      //
      birthDate.year && setBirthYear(birthDate.year);
    }
    if (deathDate) {
      //
      //
      deathDate.year && setDeathYear(deathDate.year);
    }
  }, [birthDate, deathDate]);

  const MEMORIAL_BASE =
    (typeof window !== 'undefined' && `${window.location.origin}/ripspot`) ||
    'https://ripspot.com/ripspot';
  const newURL = `${MEMORIAL_BASE}/${ripspot.id}`; // TODO: once we finish memorial page issue, fix this, we use id for the generated pages, need to look into when the page does not exist at runtime and serve it a different way locally via fetching data
  //setShareURL(newURL);

  //
  //
  return (
    <Container>
      <Content isModal={isModal}>
        <Header>
          <Title>{name || 'No Name'}</Title>
          <DatesWrapper>
            <Year>{birthYear || 'N/A'}</Year>
            <Dash />
            <Year>{deathYear || 'N/A'}</Year>
          </DatesWrapper>
        </Header>
        <PhotoGallery isPreview={isPreview} photoGallery={photoGallery} />
        {!isPreview && (
          <PinsContainer>
            <span>See all of {name || 'No Name'}'s pins:</span>
            <StyledButton primary onClick={onViewRipspotClick}>
              View On Map
            </StyledButton>
          </PinsContainer>
        )}
        <Biography>
          <div dangerouslySetInnerHTML={{ __html: bioMarkup }} />
        </Biography>
        {showComments && <Comments ripspot={ripspot} />}
        {!isPreview && (
          <SocialShare
            name={name}
            birthYear={birthYear}
            deathYear={deathYear}
            shareURL={newURL}
            isOnMemorialPage={true}
          />
        )}
      </Content>
    </Container>
  );
};

RipspotMemorial.propTypes = {
  ripspot: PropTypes.any.isRequired,
  isPreview: PropTypes.bool, // lets UI know it is coming from template OR from create ripspot process
  isModal: PropTypes.bool, // lets UI know it is being rendered within a modal, the ripspot memorial modal, opens on public pin clcisk
};

export default RipspotMemorial;

const Container = styled.div`
  ${({ theme }) => theme.styles.grow}
  color: ${({ theme }) => theme.colors.darkGrey};
  /* padding: 15px; */
  width: 100%;
  max-width: ${({ theme }) => theme.media.MAX_WIDTH}px;
  margin: 0 auto;
  margin-bottom: 40px;
`;

const Content = styled.div`
  ${({ theme, isModal }) => !isModal && theme.styles.boxShadows['2']}
  position: relative;
  width: 95%;
  margin-top: 5px;
  margin-left: auto;
  margin-right: auto;
  padding: 15px;
  padding-bottom: 6em;
  display: flex;
  flex-direction: column;
`;

const Header = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  margin-top: 5px;
  margin-bottom: 30px;
`;

const DatesWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: center;
`;

const Title = styled.h2`
  font-size: 2.05rem;
  ${({ theme }) => theme.media.min.mobile`
    font-size: 2.8rem;
  `}
  width: 100%;
  margin-bottom: 10px;
  text-align: center;
  color: ${({ theme }) => theme.colors.Primary};
`;

const Year = styled.span`
  font-size: 1.2rem;
  ${({ theme }) => theme.media.min.mobile`
    font-size: 1.6rem;
  `}
  color: ${({ theme }) => theme.colors.darkGrey};
`;

const Dash = styled.div`
  background-color: ${({ theme }) => theme.colors.darkGrey};
  height: 2px;
  width: 12px;
  margin-left: 10px;
  margin-right: 10px;
`;

const StyledButton = styled(Button)`
  align-self: center;
  margin: 1em 0;
  @media all and (max-width: 1024px) {
    order: 1;
  }
`;

const Biography = styled.section`
  max-width: ${({ theme }) => theme.media.MAX_WIDTH}px;
  width: 90%;
  padding: 15px;
  margin: 2em auto;
  > div {
    max-width: 700px;
    margin: 0 auto;
  }
  p {
    font-size: 1.3rem;
    line-height: 2;
    color: ${({ theme }) => theme.colors.Primary};
    &:not(:first-of-type) {
      margin-top: 1em;
    }
    strong {
      font-weight: 700;
    }
    em {
      font-style: italic;
    }
  }
  a {
    text-decoration: underline;
  }
  li {
    font-family: 'Montserrat', sans-serif;
    color: ${({ theme }) => theme.colors.Primary};
    font-size: 2em;
    margin: 0.4em 0;
    li {
      font-size: 1em;
    }
    strong {
      font-weight: 700;
    }
    em {
      font-style: italic;
    }
  }
  ul {
    list-style: initial;
    ul {
      list-style-type: circle;
    }
  }
  ol {
    list-style: decimal;
    ol {
      list-style-type: lower-roman;
    }
  }
  ol,
  ul {
    padding-left: 10%;
    margin: 1em 0;
    .ql-indent-1 {
      margin-left: 2em;
    }
  }
`;

const PinsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  align-content: center;
  padding-top: 4em;
  span {
    color: ${({ theme }) => theme.colors.Primary};
    font-size: 2.2em;
  }
`;
